<template>
  <div>
    <h2>Авансирование/удержание</h2>
    <br>
    <div class="row g-3">
      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="accountingMonth" class="form-label col-md-3">Расчетный месяц</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="number" min='1' max='12' step="1" class="form-control" id="accountingMonth" v-model="searchParam.accountingMonth">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="accountingYear" class="form-label col-md-3">Расчетный год</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="number" min='2024' step="1" class="form-control" id="accountingYear" v-model="searchParam.accountingYear">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="binList" class="form-label col-md-3">Список бинов:</label>
          <textarea id="binList" cols="15" rows="5" class="form-control" v-model="searchParam.binList"
                    required
                    placeholder="1234567, 1234567, ...
или
1234567
1234567
..."></textarea>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="binList" class="form-label col-md-3">Список LMS ID:</label>
          <textarea id="binList" cols="15" rows="5" class="form-control" v-model="searchParam.lmsIdList"
                    required
                    placeholder="1-1-1, 1-1-2, ...
или
1-1-1
1-1-2
..."></textarea>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="katoCode" class="form-label col-md-3">Населенный пункт</label>
          <div class="col-md-9">
            <div class="input-group">
              <multiselect
                  v-model="kato"
                  :options="katoList"
                  :searchable="true"
                  :closeOnSelect="true"
                  track-by="code"
                  :custom-label="formattedKatoLabel"
                  placeholder="Выберите Като"
                  :multiple="false"
                  :clear-on-select="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-7">
        <div class="el-input-group">
          <label v-if="hasAccess(adminWriteRoles)" class="me-3">
            <input type="checkbox" v-model="searchParam.includeDeleted" @change="fetchSearch(true)"> Показать удалённые
          </label>
          <button class="btn btn-primary" @click="fetchSearch(true)">Поиск</button>
          <button class="btn btn-warning" @click="clearSearchParam()">Сбросить фильтр</button>
        </div>
      </div>

    </div>

    <button class="open-modal-btn float-end" @click="showUploadModal = true">Загрузить Авансирование/удержание</button>

    <div v-if="showUploadModal" class="modal">
      <div class="modal-content">
        <h4>Выберите .xlsx файл для загрузки Авансирование/удержание</h4>
        <form @submit.prevent="handleUploadSubmit">
          <div class="form-group">
            <label for="accountingMonth" class="form-label">Расчетный месяц</label>
            <input type="number" min="1" max="12" step="1" v-model="accountingMonth">
          </div>
          <div class="form-group">
            <label for="accountingYear" class="form-label">Расчетный год</label>
            <input type="number" min="2023" step="1" v-model="accountingYear">
          </div>
          <div class="form-group">
            <label for="timesheetFile" class="form-label">
              Выберите .xlsx файл
              <br>
              <a href="/templates/kindergarten_retentions.xlsx">Чтобы скачать шаблон excel - нажмите по этой строке</a>
            </label>
            <input type="file" id="timesheetFile" class="form-control" required accept=".xlsx" @change="handleFileUpload">
          </div>
          <div class="form-group">
            <button type="submit" class="submit-btn" :disable="isLoading">
              {{ isLoading ? 'Загружается...' : 'Загрузить' }}
            </button>
          </div>
        </form>
        <button class="close-modal-btn" @click="showUploadModal = false">Закрыть</button>
      </div>
    </div>

    <b-pagination v-model="currentPage" :total-rows="pageResponse?.totalElements" :per-page="searchParam.perPage"></b-pagination>

    <button v-if="hasAccess(adminRoles) && selectedLive.length > 0" @click="openDeletionConfirmationModal" type="button" class="btn btn-danger">Удалить</button>
    <button v-if="hasAccess(adminWriteRoles) && selectedDeleted.length > 0" @click="showRestoreModal = true" type="button" class="btn btn-success ms-2">Восстановить</button>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <div class="col-md-4">
      <span>Элементов в странице: </span>
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-secondary" :class="{'active': searchParam.perPage == 10}" @click="fetchSearch(false)">10</button>
        <button type="button" class="btn btn-secondary" :class="{'active': searchParam.perPage == 50}" @click="fetchSearch(false)">50</button>
        <button type="button" class="btn btn-secondary" :class="{'active': searchParam.perPage == 100}" @click="fetchSearch(false)">100</button>
      </div>
    </div>

    <el-table :data="items" style="width: 100%" :row-class-name="rowClassName">
      <el-table-column type="index" label="#" width="50">
        <template v-if="hasAccess(adminRoles)" #default="scope">
          <label class="btn btn-outline-light">
            <input type="checkbox" :value="scope.row.id" v-model="selectedKindergartenRetention">
          </label>
        </template>
      </el-table-column>
      <el-table-column label="БИН" prop="bin"></el-table-column>
      <el-table-column label="LMS ID" prop="lmsId"></el-table-column>
      <el-table-column label="Расчетный месяц" prop="accountingMonth"></el-table-column>
      <el-table-column label="Расчетный год" prop="accountingYear"></el-table-column>
      <el-table-column label="Авансирование/удержание" prop="price"></el-table-column>
      <el-table-column v-if="searchParam.includeDeleted" label="Удалено">
        <template #default="scope">
          <span v-if="scope.row.deletion">{{ formatDeletion(scope.row.deletion) }}</span>
        </template>
      </el-table-column>
    </el-table>

    <DeleteReasonDialog v-model="showRestoreModal" variant="restore" title="Восстановить выбранные удержания?" confirm-text="Восстановить" reason-label="Причина восстановления" :loading="deleteLoading" @confirm="handleRestoreSelectedElements">
      <p>Выбрано записей: {{ selectedDeleted.length }}</p>
    </DeleteReasonDialog>

    <DeleteReasonDialog v-model="showDeleteConfirmationModal" title="Вы точно хотите удалить выбранные удержания?" :loading="deleteLoading" @confirm="handleDeleteSelectedElements">
      <el-table :data="deleteConfirmationContent">
        <el-table-column prop="bin" label="БИН ДО"></el-table-column>
        <el-table-column prop="lmsId" label="LMS ID"></el-table-column>
        <el-table-column prop="accountingMonth" label="Расчетным месяц"></el-table-column>
        <el-table-column prop="accountingYear" label="Расчетный год"></el-table-column>
        <el-table-column prop="retentionPrice" label="Авансирование/Удержание"></el-table-column>
      </el-table>
    </DeleteReasonDialog>
  </div>
</template>

<script lang="ts">

import {computed, defineComponent, onMounted, reactive, ref, watch} from "vue";
import {Kato, KindergartenRetention} from "@/types/kindergarten";
import cacheService from "@/services/cacheService";
import {SearchParam} from "@/types/searchParam";
import {
  deleteKindergartenRetentionList,
  restoreKindergartenRetentionList,
  findKindergartenRetention,
  uploadKindergartenRetentionXlsx
} from "@/services/kindergartenService";
import {PageResponse} from "@/types/pageResponse";
import Multiselect from "vue-multiselect";
import {ElMessage} from "element-plus";
import DeleteReasonDialog from "@/components/DeleteReasonDialog.vue";
import { SoftDeleteInfo } from "@/types/deleteRequest";
import {extractApiError} from "@/utils/apiError";
import authService from "@/services/authService";

export default defineComponent(
    {
      name: 'FactPayment',
      setup() {
        const currentPage = ref(1);
        const page = ref(1);
        const searchParam = reactive({
          perPage: 10,
          page: 1,
          binList: "",
          lmsIdList: "",
          katoCode: "",
          accountingMonth: new Date().getMonth() + 1,
          accountingYear: new Date().getFullYear(),
          includeDeleted: false,
        });
        const kato = ref<Kato | null>(null);
        const katoList = ref<Kato[]>([]);
        const isLoading = ref(false);
        const pageResponse = ref<PageResponse<KindergartenRetention>>();
        const items = ref<KindergartenRetention[]>();
        const showUploadModal = ref(false);
        const uploadedFile = ref<any>();
        const accountingMonth = ref(new Date().getMonth() + 1);
        const accountingYear = ref(new Date().getFullYear());
        const hasAccess = authService.hasAccess;
        const adminRoles: string[] = authService.getAdminRoles();
        const adminWriteRoles: string[] = authService.getAdminWriteRoles();
        const selectedKindergartenRetention = ref<number[]>([]);
        const showRestoreModal = ref(false);
        const selectedRows = (): KindergartenRetention[] => (items.value ?? []).filter((r: KindergartenRetention) => selectedKindergartenRetention.value.includes(r.id as number));
        const selectedLive = computed(() => selectedRows().filter((r: KindergartenRetention) => !r.deletion));
        const selectedDeleted = computed(() => selectedRows().filter((r: KindergartenRetention) => !!r.deletion));
        const rowClassName = ({ row }: { row: KindergartenRetention }) => (row.deletion ? "deleted-row" : "");
        const formatDeletion = (d: SoftDeleteInfo) => `${new Date(d.deletedAt).toLocaleString("ru-RU")}: ${d.deleteReason}`;

        const handleRestoreSelectedElements = async (reason: string) => {
          deleteLoading.value = true;
          try {
            await restoreKindergartenRetentionList(selectedDeleted.value.map((r: KindergartenRetention) => r.id as number), reason);
            await fetchSearch(false);
            selectedKindergartenRetention.value = [];
            showRestoreModal.value = false;
          } catch (error) {
            ElMessage({ message: extractApiError(error, "Восстановление не прошло"), type: "error", showClose: true });
          } finally {
            deleteLoading.value = false;
          }
        };
        const showDeleteConfirmationModal = ref(false);
        const deleteConfirmationContent = ref({});
        const totalCount = ref(0);
        const deleteLoading = ref(false);

        onMounted(() => {
          fetchCachedData();
        });

        const fetchCachedData = async () => {
          katoList.value = await cacheService.useKatoStore().fetchKato();
        };

        const formattedKatoLabel = (item: any) => {
          return `${item.code} | ${item.nameRu}`;
        };

        const clearSearchParam = () => {
          kato.value = null;
          searchParam.accountingMonth = new Date().getMonth() + 1;
          searchParam.accountingYear = new Date().getFullYear();
          searchParam.binList = "";
          searchParam.lmsIdList = "";
          searchParam.katoCode = "";
        }

        const searchParamSerializer = (isPageDefault: boolean = false) => {
          const searchParamResponse = new SearchParam(searchParam.perPage, 0, searchParam, reactive({}));
          if (isPageDefault) {
            searchParamResponse.partNumber = 0;
            currentPage.value = 1;
          }
          searchParamResponse.partNumber = currentPage.value;
          if (kato.value) {
            searchParamResponse.filter.katoCode = kato.value?.code;
          }
          return searchParamResponse;
        }

        const fetchSearch = async (isPageDefault: boolean = false) => {
          try {
            const searchParamResponse = searchParamSerializer(isPageDefault);
            pageResponse.value = await findKindergartenRetention(searchParamResponse);
            items.value = pageResponse.value.content;
            totalCount.value = pageResponse.value.totalElements;
          } catch (error) {
            console.error('Ошибка при получении запроса:', error);
          }
        }

        const handleUploadSubmit = () => {
          try {
            if (uploadedFile.value) {
              isLoading.value = true;
              const formData = new FormData();
              formData.append('file', uploadedFile.value);
              uploadKindergartenRetentionXlsx(accountingMonth.value, accountingYear.value, formData).then(() => {
                isLoading.value = false;
                window.location.reload();
              }).catch((error) => {
                if (error.status === 400) {
                  ElMessage({
                    message: error.response.data,
                    type: 'error',
                    duration: 0,
                    showClose: true,
                  });
                }
                isLoading.value = false;
              })
            }
          } catch(error) {
            isLoading.value = false;
            console.error(error);
          }
        }

        const handleFileUpload = (event: any) => {
          uploadedFile.value = event.target.files[0];
        }

        const openDeletionConfirmationModal = () => {
          showDeleteConfirmationModal.value = true;
          if (items && items.value) {
            deleteConfirmationContent.value = items.value
                .filter((r: KindergartenRetention) => {
                  const id = r.id;
                  return id && selectedKindergartenRetention.value.includes(id);
                })
                .map((r: KindergartenRetention) => ({
                  bin: r.bin,
                  lmsId: r.lmsId,
                  accountingMonth: r.accountingMonth,
                  accountingYear: r.accountingYear,
                  retentionPrice: r.price
                }));
          }
        }

        const handleDeleteSelectedElements = async (reason: string) => {
          deleteLoading.value = true;
          try {
            await deleteKindergartenRetentionList(selectedLive.value.map((r: KindergartenRetention) => r.id as number), reason);
            await fetchSearch(false);
            selectedKindergartenRetention.value = [];
            showDeleteConfirmationModal.value = false;
          } catch (error) {
            ElMessage({ message: extractApiError(error, "Удаление не прошло"), type: "error", showClose: true });
          } finally {
            deleteLoading.value = false;
          }
        };

        watch(currentPage, (newPage) => {
          searchParam.page = newPage;
          fetchSearch();
        });

        return {
          searchParam,
          kato,
          katoList,
          isLoading,
          showUploadModal,
          accountingYear,
          accountingMonth,
          currentPage,
          page,
          pageResponse,
          items,
          adminRoles,
          adminWriteRoles,
          selectedKindergartenRetention,
          selectedLive,
          selectedDeleted,
          showRestoreModal,
          rowClassName,
          formatDeletion,
          handleRestoreSelectedElements,
          showDeleteConfirmationModal,
          totalCount,
          deleteConfirmationContent,
          deleteLoading,
          formattedKatoLabel,
          clearSearchParam,
          fetchSearch,
          handleUploadSubmit,
          handleFileUpload,
          hasAccess,
          openDeletionConfirmationModal,
          handleDeleteSelectedElements
        };
      },
      components: {Multiselect, DeleteReasonDialog}
    }
);
</script>

<style scoped>
.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

.modal {
  display: block;
  position: fixed;
  z-index: 5;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

h4 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #45a049;
}

.close-modal-btn {
  margin-top: 10px;
  width: 100%;
  padding: 10px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.close-modal-btn:hover {
  background-color: #e31b0c;
}
</style>

<style>
.el-table .deleted-row {
  background-color: #fdecea;
  color: #8a8a8a;
}
</style>
